import { gql } from '@apollo/client';

export const ADMIN_PAYMENTS_QUERY = gql`
  query AdminPayments(
    $after: String
    $first: Int
    $orderBy: String
    $order: String
  ) {
    adminPayments(
      after: $after
      first: $first
      orderBy: $orderBy
      order: $order
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        kind
        amount
        state
        scheduledAt
        createdAt
        paymentProvider
        venue {
          id
          name
          users {
            id
            magicLoginLink
          }
        }
        event {
          id
          name
        }
        paymentMethod {
          id
          mechanism
          brand
        }
      }
    }
  }
`;
